import { useEffect, useState } from 'react'
import { UrlApi } from '../../services/apirest'
import { Button, TextField, Box, LinearProgress } from '@mui/material'
import { Container } from '@mui/system'
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import moment from 'moment'
import { DataGrid, GridToolbar, esES } from '@mui/x-data-grid'
import Viajes from './Viajes'

export default function Resumen() {
    const [veresto, setVerEsto] = useState(true)
    const [fechaDesde, setFechaDesde] = useState(moment(Date()).format('YYYY-MM-DD'))
    const [fechaHasta, setFechaHasta] = useState(moment(Date()).format('YYYY-MM-DD'))
    const [dataviajes, setDataViajes] = useState([])
    const eschofer = localStorage.getItem('patente').length > 4
    const esAdmin = localStorage.getItem('adminT1') === 1
    const [data, setData] = useState([])
    const [editviaje, setEditViaje] = useState(false)

    useEffect(() => {
        buscardatos()
    }, [veresto])

    const buscardatos = async () => {
        const data = await fetch(
            !eschofer
                ? UrlApi + '/viajest1/entre/' + fechaDesde + '/' + fechaHasta
                : UrlApi +
                '/viajest1/porchofer/' +
                fechaDesde +
                '/' +
                fechaHasta +
                '/' +
                localStorage.getItem('user')
        )
        const datav = await data.json()
        setDataViajes(datav)
        datav && console.log(datav)
    }

    const handleOnCellClick = params => {
        return esAdmin && params.row.fechaviaje
            ? [setData(params.row), setEditViaje(true), setVerEsto(false)]
            : null
    }

    const columns = [
        { field: 'idviajes_t1', headerName: 'Viaje#', width: 70 },
        {
            field: eschofer ? 'chofer' : 'nombreapellido',
            headerName: 'Chofer',
            width: 150,
        },
        {
            field: 'dominio',
            headerName: 'Vehiculo',
        },
        {
            field: 'fechaviaje',
            headerName: 'Inicio',
            width: 100,
            valueFormatter: params => params?.value !== "" ?
                moment(params?.value).format("DD/MM/YYYY") : "",
        },
        {
            field: 'fechafinal',
            headerName: 'Final',
            width: 100,
            valueFormatter: params => params?.value !== "" ?
                moment(params?.value).format("DD/MM/YYYY") : "",
        },
        {
            field: 'desde',
            headerName: 'Origen',
            width: 170,
        },
        {
            field: 'bocacarga',
            headerName: 'BocaCarga',
            width: 170,
        },
        {
            field: 'hasta',
            headerName: 'Destino',
            width: 170,
        },
        {
            field: 'feriado',
            headerName: 'Feriado',
        },
        {
            field: 'vacio',
            headerName: 'Vacio',
        },
        {
            field: 'kmsinicio',
            headerName: 'KmsInicio',
        },
        {
            field: 'kmsfinal',
            headerName: 'KmsFinal',
        },
        {
            field: 'remito',
            headerName: 'Remito',
        },
        {
            field: 'TotalKms',
            headerName: 'TotalKms',
        },
    ]

    return (
        <div>
            {veresto && (
                <>
                    <br></br>
                    <br></br>
                    <br></br>
                    <br></br>
                    <Box sx={{ paddingLeft: 5 }}>
                        <LocalizationProvider dateAdapter={AdapterMoment}>
                            <DesktopDatePicker
                                required
                                label='Fecha desde'
                                //type="datetime-local"
                                inputFormat='DD/MM/yyyy'
                                //minDate={moment(fechaHasta)}
                                //maxDate={moment(periodo[0].hasta)}
                                value={fechaDesde}
                                onChange={e => setFechaDesde(moment(e).format('YYYY-MM-DD'))}
                                renderInput={params => <TextField size='small' {...params} />}
                                onKeyDown={e => {
                                    e.preventDefault()
                                }}
                            />
                            <DesktopDatePicker
                                required
                                label='Fecha Hasta'
                                //type="datetime-local"
                                inputFormat='DD/MM/yyyy'
                                minDate={moment(fechaDesde)}
                                //maxDate={moment(periodo[0].hasta)}
                                value={fechaHasta}
                                onChange={e => setFechaHasta(moment(e).format('YYYY-MM-DD'))}
                                renderInput={params => <TextField size='small' {...params} />}
                                onKeyDown={e => {
                                    e.preventDefault()
                                }}
                            />
                        </LocalizationProvider>
                        <Button variant='outlined' color='success' onClick={buscardatos}>
                            Buscar viajes
                        </Button>
                    </Box>
                    {console.log(dataviajes)}
                    <Box sx={{ height: 500, width: '90%', pt: '10px', paddingLeft: 5 }}>
                        {dataviajes ? (
                            <DataGrid
                                header={'hola'}
                                getRowId={row => row.idviajes_t1} //importante poner un key
                                rows={dataviajes}
                                columns={columns}
                                pageSize={10}
                                rowsPerPageOptions={[10]}
                                pagination
                                //hideFooter={true}
                                //checkboxSelection
                                disableSelectionOnClick
                                experimentalFeatures={{ newEditingApi: true }}
                                components={{
                                    Toolbar: GridToolbar,
                                }}
                                componentsProps={{
                                    panel: {
                                        sx: {
                                            '& .MuiTypography-root': {
                                                color: 'teal',
                                                fontSize: 12,
                                            },
                                            '& .MuiDataGrid-filterForm': {
                                                bgcolor: 'lightblue',
                                            },
                                        },
                                    },
                                    toolbar: {
                                        showQuickFilter: true,
                                        quickFilterProps: { debounceMs: 500 },
                                    },
                                }}
                                onCellClick={handleOnCellClick}
                                localeText={esES.components.MuiDataGrid.defaultProps.localeText}
                                showColumnRightBorder
                                showCellRightBorder
                                disableDensitySelector={true}
                                disableColumnFilter={true}
                                disableColumnSelector={true}
                                density='compact'
                                sx={{
                                    boxShadow: 2,
                                    border: 2,
                                    borderColor: 'primary.light',
                                    '& .MuiDataGrid-cell:hover': {
                                        color: 'primary.main',
                                    },
                                }}
                            />
                        ) : null}
                    </Box>
                </>
            )}
            {editviaje ? (
                <Viajes
                    datos={data}
                    setOpenViajes={setEditViaje}
                    setOpenViajesMostrar={setVerEsto}
                    editar={true}
                    deresumen={true}
                />
            ) : null}
        </div>
    )
}
